import React from 'react';

const AppProgress = props => {
  const {currentStep} = props;
  let width;
  switch (currentStep) {
    case 2:
      width = '33.333%';
      break;
    case 3:
      width = '66.666%';
      break;
    case 4:
    case 5:
      width = '100%';
      break;
    default:
      width = '0%';
      break;
  }

  return (
    <div className="appProgress">
      <div className="appProgressBar" style={{width}} />
    </div>
  );
};

export default AppProgress;
